import { UserAgentApplication, ClientAuthError } from 'msal';
import { setAccessToken, setProfilePicAccessToken } from 'redux/actions';
import store from 'redux/store';
import appConfig from 'config';

export const isIE = () => {
	const ua = window.navigator.userAgent;
	const msie = ua.indexOf('MSIE ') > -1;
	const msie11 = ua.indexOf('Trident/') > -1;

	return msie || msie11;
};

export const authAgent = new UserAgentApplication({
	auth: {
		clientId: appConfig.clientId,
		authority: appConfig.authority,
		redirectUri: appConfig.redirectUri,
		postLogoutRedirectUri: appConfig.logoutUri,
		validateAuthority: true,
		navigateToLoginRequestUrl: false,
	},
	cache: {
		cacheLocation: 'localStorage',
		storeAuthStateInCookie: isIE(),
	},
});

authAgent.handleRedirectCallback((error: any, response: any) => {
	if (error) {
		throw new ClientAuthError('');
	}

	if ('tokenType' in response && response.tokenType === 'access_token') {
		if (response.scopes[0] === appConfig.appScopes[0]) {
			store.dispatch(setAccessToken(response.accessToken, response.expiresOn));
		} else if (response.scopes[0] === appConfig.profilePicAppScopes[0]) {
			store.dispatch(setProfilePicAccessToken(response.accessToken, response.expiresOn));
		}
	}
});

export const requiresInteraction = (errorMessage: string) => {
	if (!errorMessage || !errorMessage.length) {
		return false;
	}

	return errorMessage.indexOf('consent_required') > -1 || errorMessage.indexOf('interaction_required') > -1 || errorMessage.indexOf('login_required') > -1;
};

export const loginUserWithRedirect = async (agent: UserAgentApplication) => {
	await agent.loginRedirect({
		scopes: appConfig.appScopes,
		redirectUri: appConfig.redirectUri,
	});
};

export const loginUserWithSSO = async (agent: UserAgentApplication) => {
	await agent.ssoSilent({
		scopes: appConfig.appScopes,
		redirectUri: appConfig.redirectUri,
		extraQueryParameters: { domain_hint: 'EMCloudAD.onmicrosoft.com' },
	});
};

export const getAccessTokenSilent = async (agent: UserAgentApplication) => {
	return await agent.acquireTokenSilent({
		scopes: appConfig.appScopes,
	});
};

export const getProfilePicAccessTokenSilent = async (agent: UserAgentApplication) => {
	return await agent.acquireTokenSilent({
		scopes: appConfig.profilePicAppScopes,
	});
};

export const getAccessTokenPopup = async (agent: UserAgentApplication) => {
	return await agent.acquireTokenPopup({
		scopes: appConfig.appScopes,
		redirectUri: appConfig.redirectUri,
	});
};

export const getProfilePicAccessTokenPopup = async (agent: UserAgentApplication) => {
	return await agent.acquireTokenPopup({
		scopes: appConfig.profilePicAppScopes,
		redirectUri: appConfig.redirectUri,
	});
};

export const getAccessTokenInteractive = async (agent: UserAgentApplication) => {
	return await agent.acquireTokenRedirect({
		scopes: appConfig.appScopes,
		redirectUri: appConfig.redirectUri,
	});
};

export const getProfilePicAccessTokenInteractive = async (agent: UserAgentApplication) => {
	return await agent.acquireTokenRedirect({
		scopes: appConfig.profilePicAppScopes,
		redirectUri: appConfig.redirectUri,
	});
};
